import { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import { axiosInstance } from './api';

export class NetworkRequestHandler {
  static sendRequest = async ({
    url,
    method,
    data,
    headers,
    params,
    responseType,
  }: AxiosRequestConfig) => {
    const responseData = await axiosInstance({
      method,
      url,
      data,
      params,
      headers,
      responseType,
      paramsSerializer: (param) =>
        qs.stringify(param, { arrayFormat: 'repeat' }),
    });
    return responseData.data;
  };
}
